import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'components/Grid';
import HomeWidgetErrorBoundary from './HomeWidgetErrorBoundary';
import widgetManager, { wrappedWidgets } from './widgetManager';

// One object for every widget without a config, so its error boundary sees no change
const noConfig = {};

const HomeWidget = ({ type, config = noConfig }) => {

  const Component = widgetManager[type];

  if (!Component) {
    console.error(`Unsupported home widget of type ${type}.`);
    return null;
  }

  // Widgets render as the grid item itself, so one with nothing to show takes no spacing
  return (
    <HomeWidgetErrorBoundary type={type} config={config}>
      {wrappedWidgets.includes(type)
        ? <Grid item><Component {...config} /></Grid>
        : <Grid item component={Component} {...config} />}
    </HomeWidgetErrorBoundary>
  );
};

HomeWidget.propTypes = {
  type: PropTypes.oneOf(Object.keys(widgetManager)).isRequired,
  config: PropTypes.object,
};

export default HomeWidget;
